/* ============================================================
   Vantor — ATC summary + sticky ATC footer painter (app-236; app-240 real cart).
   Shared by the PDPs and the builder. Prices for add-ons appear
   HERE and only here — never on the chooser tiles.
   ============================================================ */
(function (V) {
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /**
   * paint(q, opts)
   *   q    — Vantor.quote() result; null, or { blocked: 'label' }, when the selection isn't purchasable
   *   opts — { cfg: 'short config line', blocked: 'button label when q is null' }
   * Vantor.lastQuote is what vantor-cart.js adds: exactly the quote that was painted, or null.
   */
  V.paintSummary = function (q, opts) {
    opts = opts || {};
    var $ = function (sel) { return document.querySelector(sel); };
    var lines = $('[data-summary-lines]'), total = $('[data-summary-total]'), split = $('[data-summary-split]');
    var btns = document.querySelectorAll('[data-atc]');

    if (opts.cfg != null) document.querySelectorAll('[data-atc-cfg]').forEach(function (n) { n.textContent = opts.cfg; });
    document.querySelectorAll('[data-atc-error]').forEach(function (n) { n.hidden = true; n.textContent = ''; });

    var blocked = !q ? (opts.blocked || 'Unavailable') : q.blocked;
    // TPC-1054: while purchasing is paused every button reads Unavailable, never "sold out"
    if (V.purchasing === false) blocked = 'Unavailable';
    V.lastQuote = blocked ? null : q;
    if (blocked) {
      if (lines) lines.innerHTML = '<li class="summary__line"><span>' + esc(blocked) + '</span><span>—</span></li>';
      if (total) total.textContent = '—';
      if (split) split.hidden = true;
      document.querySelectorAll('[data-atc-label]').forEach(function (n) { n.textContent = 'Total'; });
      document.querySelectorAll('[data-atc-amount]').forEach(function (n) { n.textContent = '—'; });
      btns.forEach(function (b) { b.disabled = true; b.textContent = blocked; });
      return;
    }

    if (lines) lines.innerHTML = q.lines.map(function (l) {
      return '<li class="summary__line' + (l.save ? ' summary__line--save' : '') + '"><span>' + esc(l.label) +
        (l.note ? '<small>' + esc(l.note) + '</small>' : '') + '</span><span>' + V.money(l.amount) + '</span></li>';
    }).join('');
    if (total) total.textContent = V.money(q.total);
    if (split) {
      split.hidden = !q.presale;
      var d = $('[data-summary-due]'), r = $('[data-summary-rem]');
      if (d) d.textContent = V.money(q.dueToday);
      if (r) r.textContent = V.money(q.remainder);
    }
    document.querySelectorAll('[data-atc-label]').forEach(function (n) { n.textContent = q.presale ? 'Due today' : 'Total'; });
    document.querySelectorAll('[data-atc-amount]').forEach(function (n) { n.textContent = V.money(q.presale ? q.dueToday : q.total); });
    btns.forEach(function (b) {
      b.disabled = false;
      b.textContent = q.depositOnly ? 'Preorder — ' + V.money(q.dueToday) + ' deposit'
        : q.presale ? 'Add to cart — ' + V.money(q.dueToday) + ' today'      // mixed: in-stock lines in full + a deposit
        : 'Add to cart — ' + V.money(q.total);
    });
  };
})(window.Vantor);
